<template>
    <div id="footer" class="footer-component footer-container">
        <div class="navbar" id="navbar-footer"> 
            <ul class="navbar-nav">
                <li class="nav-item dropdown" v-for="(rootItem, index) in footer" :key="index">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">{{ rootItem.languageFamilyList.find(l => l.lang == $i18n.locale).content }}</a>
                    <div class="dropdown-menu dropdown-menu-right animate">
                        <template v-for="(secondItem, index) in rootItem.subMenu" :key="index">
                            <router-link v-if="!secondItem.link?.includes('news')" class="dropdown-item" :to="clickFooter(rootItem, secondItem)">
                                {{ secondItem.languageFamilyList.find(l => l.lang == $i18n.locale).content }}
                            </router-link>
                        </template>
                    </div>
                </li>
            </ul>
        </div>
        <div class="contact">Contact</div>
        <div class="social-media">
                <router-link :to="{ name: 'contactUs' }"><img src="@/assets/images/footer/business.png" alt="business"></router-link>
                <a href="https://www.linkedin.com/company/pegatron/posts/?feedView=all"><img src="@/assets/images/footer/linkin.png" alt="linkin"></a>
                <a href="https://www.instagram.com/pegatron_go/"><img src="@/assets/images/footer/ig.png" alt="instagram"></a>
                <a href="https://www.youtube.com/@pegatroncorp.6158/videos"><img src="@/assets/images/footer/youtube.png" alt="youtube"></a>
            </div>
        <div class="bottom">
            <div class="copyright">© PEGATRON Corporation. All rights reserved</div>
            <div class="function">
                <router-link :to="{ name: 'contactUs' }" class="footer-link footer-link-border">{{ $t('footer.contactUs') }}</router-link>
                <router-link :to="{ name : 'privacy'}" class="footer-link footer-link-border">{{ $t('footer.privacyAndCookiesPolicy') }}</router-link>
                <a href="#" class="footer-link footer-link-nopadding" @click.prevent="$store.dispatch('cookieConsent/openSettingsFromFooter')">{{ $t('footer.cookieSettings') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import store from "@/store"
import menuMixin from '@/mixins/menuMixin';
export default{
    name: 'FooterComponent',
    mixins: [menuMixin],
    data(){
        return{
            footer: store.state.menu,
        }
    },
}
</script>

<style src="@/assets/css/footer_other.css" scoped></style>
<style scoped>
.footer-link {
    color: inherit;
    text-decoration: none;
    padding-right: 16px;
}
.footer-link-border {
    border-right: 1px solid #3a3a3a;
}
.footer-link-nopadding {
    padding-right: 0 !important;
}
</style>